export default __webpack_public_path__ + "static/media/dreamroom.7e738e3b.jpg";